import React from "react";
import { POSTER_IMG, POSTER_ALT } from "../lib/constants";

/**
 * Framed event poster (portrait 2:3). The artwork carries its own border
 * treatment, so nothing is layered on top of it — the soft glow sits behind.
 * width/height are set to reserve the aspect ratio (no CLS); lazy by default
 * so it never becomes the mobile LCP element.
 */
export default function PosterFrame({ className = "", maxW = 360 }) {
  return (
    <div className={`relative mx-auto w-full ${className}`} style={{ maxWidth: maxW }}>
      <div className="absolute -inset-2 rounded-[20px] bg-gradient-to-br from-[#C9A961]/25 to-transparent blur-xl" aria-hidden="true" />
      <img
        src={POSTER_IMG}
        alt={POSTER_ALT}
        width="848"
        height="1264"
        loading="lazy"
        decoding="async"
        className="relative block w-full h-auto rounded-[14px] border border-[#C9A961]/30 shadow-[0_30px_80px_-24px_rgba(0,0,0,0.7)]"
      />
    </div>
  );
}
